import { render, staticRenderFns } from "./ScanAlert.vue?vue&type=template&id=a67a0eea&scoped=true"
import script from "./ScanAlert.vue?vue&type=script&lang=js"
export * from "./ScanAlert.vue?vue&type=script&lang=js"
import style0 from "./ScanAlert.vue?vue&type=style&index=0&id=a67a0eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a0eea",
  null
  
)

export default component.exports